// services/cultureService.js
import apiClient from './apiClient';

// Tüm culture'ları getir
export const getAllCultures = async () => {
  const response = await apiClient.post('/culture/GetAllCultures');
  return response.data.Data.Items || [];
};

// ID'ye göre culture getir
export const getCultureById = async (id) => {
  const response = await apiClient.post('/culture/GetCultureById', { id });
  return response.data;
};

// services/cultureTextService.js

// Tüm culture text'leri getir
export const getAllCultureTexts = async () => {
  const response = await apiClient.post('/culture/GetAllCultureTexts');
  return response.data;
};

// Culture ID'ye göre culture text'leri getir
export const getCultureTextByCultureId = async (cultureId) => {
  const response = await apiClient.post('/culture/GetCultureTextByCultureId', { id: cultureId });
  return response.data;
};

// ID'ye göre culture text getir
export const getCultureTextById = async (id) => {
  const response = await apiClient.post('/culture/GetCultureTextById', { id });
  return response.data;
};

// Yeni culture text ekle
export const addCultureText = async (cultureTextData) => {
  const response = await apiClient.post('/culture/AddCultureText', cultureTextData);
  return response.data;
};

// Culture text güncelle
export const updateCultureText = async (cultureTextData) => {
  const response = await apiClient.post('/culture/UpdateCultureText', cultureTextData);
  return response.data;
};

// Culture text sil
export const deleteCultureText = async (id) => {
  const response = await apiClient.post('/culture/DeleteCultureText', { id });
  return response.data;
};